import { createClient } from '@supabase/supabase-js';

// Safely initialize Supabase. If env vars are missing, avoid crashing the app and log a helpful warning.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let client: ReturnType<typeof createClient> | null = null;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // eslint-disable-next-line no-console
  console.warn(
    '[Supabase] Missing VITE_SUPABASE_URL and/or VITE_SUPABASE_ANON_KEY.\n' +
      'Create a .env.local file at the project root with:\n' +
      'VITE_SUPABASE_URL=your-url\n' +
      'VITE_SUPABASE_ANON_KEY=your-anon-key\n' +
      'The app will continue to run, but any Supabase-backed features will be disabled.'
  );
} else {
  // Validate URL format to avoid runtime failures in the SDK (new URL())
  const sanitizedUrl = (SUPABASE_URL || '').trim();
  const isValidUrl = typeof sanitizedUrl === 'string' && /^https?:\/\//i.test(sanitizedUrl);
  if (!isValidUrl) {
    // eslint-disable-next-line no-console
    console.error('[Supabase] Invalid VITE_SUPABASE_URL. Expected full https://...supabase.co URL. Received:', sanitizedUrl);
  } else {
    try {
      // Pre-validate with URL constructor to mirror SDK behavior and catch early
      // Do not log full URL; only origin for privacy
      const { origin } = new URL(sanitizedUrl);
      // eslint-disable-next-line no-console
      console.info('[Supabase] Initializing client for origin:', origin);

      client = createClient(sanitizedUrl, SUPABASE_ANON_KEY, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[Supabase] Failed to initialize client. Check URL/Key.', e);
      client = null;
    }
  }
}

export const supabase = client;